interface ImageData {
  images: string[];
  mobileImages: string[];
}

export const useProductDisplayBlock = () => {
  const model = document.getElementById('product-display-block-model') as HTMLElement;
  const loadingSpinner = model.querySelector('.loading-spinner') as HTMLElement;
  const imageDataScript = document.querySelector('.product-display-block__images-json') as HTMLScriptElement;
  const imageData: ImageData = JSON.parse(imageDataScript.textContent!) as ImageData;
  const autoStart = document.querySelector('.product-display-block__content')
      ?.classList.contains('product-display-block__content--autostart');
  const startImage = document.querySelector('.product-display-block__start-image') as HTMLElement;

  // Use desktop images if screen width is wider than 560px, otherwise use mobile images
  const images = window.innerWidth > 1154 ? imageData.images : imageData.mobileImages;
  const totalImages = images.length;

  let currentImageIndex = 0;
  let isDragging = false;
  let startX = 0;
  const icon360 = document.querySelector('.product-display-block__image360') as HTMLElement;
  let loadedImages = 0;

  // Initialize using button
  if (!autoStart) {
    icon360.hidden = false;
    loadingSpinner.hidden = true;

    icon360.addEventListener('click', () => {
      initialize();
    });
    return;
  }

  // Autoload
  initialize();

  function initialize() {
    loadingSpinner.hidden = false;
    icon360.hidden = true;

    // Load images
    images.forEach((imageSrc, index) => {
      const img: HTMLImageElement = document.createElement('img');
      img.src = imageSrc;
      img.hidden = true;
      model.appendChild(img);

      // Image loaded
      img.onload = () => {
        loadedImages++;
        checkImagesLoaded();
      };

      // Image not found but still count as loaded
      img.onerror = () => {
        loadedImages++;
        checkImagesLoaded();
      };
    });

    const imageElements: NodeListOf<HTMLImageElement> = document.querySelectorAll('#product-display-block-model > img');

    function checkImagesLoaded() {
      if (loadedImages === totalImages) {
        // Hide loading spinner after all images are loaded
        loadingSpinner.hidden = true;

        // Show heading after all images are loaded
        let heading = document.querySelector('.product-display-block__heading') as HTMLHeadingElement;

        if (!!heading) {
          heading.hidden = false;
        }

        icon360.hidden = true;
        startImage.hidden = true;

        // Add loaded class
        document.querySelector(".product-display-block")?.classList.add('product-display-block__model--loaded');

        // Show all images after they are loaded
        document.getElementById('product-display-block-model')?.querySelectorAll('img').forEach((img) => {
          img.hidden = false;
        });
        
        // Start on index 0
        showImage(0);
      }
    }

    function showImage(index: number): void {
      imageElements.forEach(img => img.hidden = true);
      imageElements[index].hidden = false;
    }

    
    function handleMouseDown(event: MouseEvent | TouchEvent): void {
      if (event instanceof MouseEvent) {
        event.preventDefault();
        // Only start if left (0) or right (2) button
        if (event.button === 0 || event.button === 2) {
          isDragging = true;
          startX = event.clientX;
          model.style.cursor = 'grabbing';
        }
        return;
      }
      
      if (event instanceof TouchEvent) {
        if (event.touches.length === 0) return;
        isDragging = true;
        startX = event.touches[0].clientX;
        model.style.cursor = 'grabbing';
      }
    }

    function handleMouseMove(event: MouseEvent | TouchEvent): void {
      if (!isDragging) return;

      if (event instanceof MouseEvent) {
        event.preventDefault();
        const currentX = event.clientX;
        const deltaX = currentX - startX;

        if (Math.abs(deltaX) > 5) {
          if (deltaX > 0) {
            currentImageIndex = (currentImageIndex + 1) % totalImages;
          } else {
            currentImageIndex = (currentImageIndex - 1 + totalImages) % totalImages;
          }
          showImage(currentImageIndex);
          startX = currentX;
        }
        return;
      }
      
      if (event instanceof TouchEvent) {
        if (event.touches.length === 0) return;
        const currentX = event.touches[0].clientX;
        const deltaX = currentX - startX;

        if (Math.abs(deltaX) > 5) {
          if (deltaX > 0) {
            currentImageIndex = (currentImageIndex + 1) % totalImages;
          } else {
            currentImageIndex = (currentImageIndex - 1 + totalImages) % totalImages;
          }
          showImage(currentImageIndex);
          startX = currentX;
        }
      }
    }

    function handleMouseUp(): void {
      isDragging = false;
      model.style.cursor = 'grab';
    }
    
    model.addEventListener('mousedown', handleMouseDown);
    model.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    model.addEventListener('touchstart', handleMouseDown);
    model.addEventListener('touchmove', handleMouseMove);
    window.addEventListener('touchend', handleMouseUp);
  }
};

document.addEventListener('DOMContentLoaded', useProductDisplayBlock);
